import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { DynamicAuditTrailComponent, PopupData } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit {
  @Input() data: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  formsList: any = [];
  formsListTemp: any = [];
  formData: any;
  makeStickyColumns: any;
  dataTypeList: any = [];

  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, private snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private elem: ElementRef) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages


  //page = 1;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.formsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.formsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    // if (page < 1 || page > this.pager.totalPages) {
    //   return;
    // }
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.formsListTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.formsListTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.formsListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }
  @ViewChild
    (EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    //this.visibleviwerClobPopup = this.dialog.open(this.viwerClobPopup, this.aviwerlPopupConfig);
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe((Response: any) => {
      console.log(Response.result);
      this.htmlContent = Response.result;
      this.editorComponent.openEditor(this.htmlContent, colunName);
    }, (error) => {
      console.log(error);

    })
    this.isProcessing = false;

  }
  htmlContent: any;
  getcallMethod() {
    this.isProcessing = true;
    this.formsList = [];
    const data = {

      gridName: "FORMS"
    }
    this.appService.getDynamicGridHeaders(data).subscribe((response: any) => {

      if (response.orderByClause == null) {
        response.orderByClause = "";
      }

      this.makeStickyColumns = response.fixedFieldCnt;

      const data1: any = {

        gridName: "ONEQMS_FORMS_VW",
        tableOrViewName: response.tableOrViewName == null ? "" : response.tableOrViewName,
        columnsList: response.columnsList == null ? "" : response.columnsList,
        fieldLabelsList: response.fieldLabelsList == null ? "" : response.fieldLabelsList,
        invisibleColumn: response.invisibleColumn == null ? "" : response.invisibleColumn,
        orderByClause: response.orderByClause == null ? "" : response.orderByClause,
        fieldSizeList: response.fieldSizeList == null ? "" : response.fieldSizeList,
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        templateIdFromQmsReportTemplate: this.data.templateId,
        manualEntryDataFields: response.manualEntryDataFields,
        clobColumnlist: response.closblist || "",
        blobColumnlist: response.bloblist || ""
      }
      this.reportObj = { ...data1, ...data };
      this.appService.getDynamicGridData(data1).subscribe((response1: any) => {
        this.formsList = response1;
        console.log('Data - ', this.formsList);
        data1.columnsListarray = data1.columnsList.split(",");
        data1.fieldColumnarray = data1.fieldLabelsList.split(",");
        data1.invisibleColumnarray = data1.invisibleColumn.split(",");
        data1.fieldSizeListArray = data1.fieldSizeList.split(",");
        let rendereddata: any;

        /* for(let i=0;i<response1.length;i++){
          this._temp={};
          for(let j=0;j<data1.columnsListarray.length;j++){
            let columnname=data1.columnsListarray[j];
            this._temp[columnname] = response1[i][j];
          }
          this.trainingParameterTemplateDataForGrid.push(this._temp);
        } */

        this.columnLists.columnsListarray = data1.columnsListarray;
        this.columnLists.fieldLabelsList = data1.fieldLabelsList;
        this.columnLists.fieldColumnarray = [];
        for (let p = 0; p < data1.fieldColumnarray.length; p++) {
          this.columnLists.fieldColumnarray.push({
            "fieldColumnarray": data1.fieldColumnarray[p],
            "width": data1.fieldSizeListArray[p] + 'px'
          })
        }
        this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
        this.columnLists.fieldSizeListArray = [];
        for (let w = 0; w < data1.fieldSizeListArray.length; w++) {
          this.columnLists.fieldSizeListArray.push(data1.fieldSizeListArray[w] + 'px');
        }

        for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
          for (let k = 0; k < this.columnLists.invisibleColumnarray.length; k++) {
            if (this.columnLists.columnsListarray[y] == this.columnLists.invisibleColumnarray[k]) {
              this.columnLists.columnsListarray.splice(y, 1);
              this.columnLists.fieldColumnarray.splice(y, 1);
              this.columnLists.fieldSizeListArray.splice(y, 1);
            }
          }
        }

        let tableData = {
          tablename: data1.tableOrViewName
        };
        this.columnLists.columnsListarray1 = [];
        this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
          //console.log(response2);
          this.dataTypeList = response2;
          for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
            this.columnLists.columnsListarray1.push({});
            this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
            this.columnLists.columnsListarray1[m].dataType = "textbox";
            this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
            for (let w = 0; w < this.dataTypeList.length; w++) {
              if (this.dataTypeList[w].columnName == this.columnLists.columnsListarray[m]) {
                this.columnLists.columnsListarray1[m].dataType = this.dataTypeList[w].fieldType;
              }
            }
          }
          //console.log(this.columnLists.columnsListarray1);
          for (let i = 0; i < this.formsList.length; i++) {
            for (let y = 0; y < this.dataTypeList.length; y++) {
              if (this.dataTypeList[y].fieldType == 'CHECKBOX') {
                this.formsList[i][this.dataTypeList[y].columnName] = this.formsList[i][this.dataTypeList[y].columnName] == "Y" ? true : false;
              }
            }

          }
          //this.trainingParameterTemplateDataForGrid=this.trainingParameterTemplateDataForGrid;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          //console.log(this.trainingParameterTemplateDataForGrid);
          this.setPage(1, 0);
          this.pager.totalPages = undefined;
          this.labelcall();
        });
        this.message.gridList = this.formsList;
        this.collectionSize = this.formsList.length;
        this.totalPages = Math.ceil(this.formsList.length / this.itemsPerPage);

        //this.updateDisplayedData();
      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
      this.isProcessing = false;
    }, (error) => {
      this.isProcessing = false;
      throw error;
    });

  }


  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe((data: any) => {
      this.label = data;
      this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
        acc[`${user.columnName}`] = user.changedFieldName;
        return acc;
      }, {});
      console.log(this.dynamicLabel);
      this.isProcessing = false;
      //this.label = data;
    }, (error: any) => {
      this.isProcessing = false;
    });
  }

  ngOnInit() {


  }

  ngOnChanges() {
    this.getcallMethod();
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.formsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.formsList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.formsListTemp = this.formsList;
      this.pager = this.paginationService.getPager(this.formsListTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.formsListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      /* this.trainingParameterTemplateDataForGridTemp = this.trainingParameterTemplateDataForGrid.filter((item: { subject: string; date: { toString: () => string | string[]; }; }) =>
        item.subject?.toLowerCase().includes(filter) ||
        item.date?.toString().includes(filter)
      ); */
      if (this.formsList == undefined) {
        return this.formsList;
      }
      if (!this.formsList.length) {
        return this.formsList;
      }
      if (filter != undefined) {
        this.formsListTemp = this.formsList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
        //this.totalPages = Math.ceil(this.trainingParameterTemplateDataForGridTemp.length / this.itemsPerPage);
        //this.pager.totalPages=this.totalPages ;

      } else {
        this.formsListTemp = this.formsList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
        //this.totalPages = Math.ceil(this.trainingParameterTemplateDataForGridTemp.length / this.itemsPerPage);
        //this.pager.totalPages=this.totalPages ;
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.formsList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column as string;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    //let stickycount = 4;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            let previousColumn = elements1[key - 1];
            //console.log(previousColumn.style.offsetWidth);
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          let keyValue = p / 2;
          column.style.background = keyValue == Math.floor(keyValue) ? 'white' : 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          //column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }


  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      this.childCheckBoxs = true;
      for (let p = 0; p < this.formsList.length; p++) {
        this.formsList[p].childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (let p = 0; p < this.formsList.length; p++) {
        this.formsList[p].childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.formsList[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  formName: any;
  formNameRequiredMsg: any;
  fieldValidation() {
    this.formName = document.getElementById('formName') as HTMLInputElement;
    this.formNameRequiredMsg = document.getElementById('formName-required-msg') as HTMLInputElement;

    if (this.formData.formName == "") {
      this.formName.style.border = '1px solid red';
      this.formNameRequiredMsg.style.display = 'block';
    } else {
      this.formName.style.border = 'none';
      this.formNameRequiredMsg.style.display = 'none';
    }
  }

  onFieldFocusout() {
    if (this.formNameRequiredMsg != undefined) {
      this.formName.style.border = 'none';
      this.formNameRequiredMsg.style.display = 'none';
    }

    if (this.deleteFiledValueRequiredMsg != undefined) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }


  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Form";
    this.formData = {};
    this.formData.formName = '';
    this.formData.formDescription = null;
    this.formData.header = null;
    this.formData.footer = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  positionValue: any = 1;
  filteredStages: any = [];
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleReasonForUpdateField = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Form"
    this.appService.getFormByFormId(editRowData.FORM_ID).subscribe((response: any) => {
      this.isProcessing = false;
      this.formData = response[0];
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshGridData() {
    this.getcallMethod();
  }

  addAndEditFunction(formData: any) {
    this.isProcessing = true;
    if (formData.formName == "") {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      if (this.operationFlag == 'ADD') {

        formData.templateId = this.data.templateId;
        this.appService.addForm(formData).subscribe((Response: any) => {
          if (Response.resultType == "S") {
            this.getcallMethod();
            this.visibleAddAndEditPopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel == null ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.isProcessing = false;
          throw error;
        });
      } else {
        delete formData.createdOn;
        delete formData.updatedOn;


        if (formData.lastActionOn != null) {
          formData.lastActionOn = new Date(formData.lastActionOn);
        }
        if (formData.lockedOn != null) {
          formData.lockedOn = new Date(formData.lockedOn);
        }
        this.appService.updateForm(formData).subscribe((Response: any) => {
          if (Response.resultType == 'S') {
            this.getcallMethod();
            this.visibleAddAndEditPopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel == null ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = true;
        }, (error) => {
          this.isProcessing = false;
          throw error;
        });

      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFormFormId: any;
  openDeletePopup(deleteRowData: any) {
    this.formData = deleteRowData;
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Form";
    this.deleteFormFormId = deleteRowData.FORM_ID;
    if (this.formData.deleteReason != undefined) {
      this.formData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFormTemplateData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {

        templateId: this.data.templateId,
        formId: this.deleteFormFormId,
        deleteReason: this.formData.deleteReason,
      }
      this.appService.deleteForm(data).subscribe((Response: any) => {
        if (Response.resultType == 'S') {
          this.getcallMethod();

        }
        this.visibleDeletePopup.close();
        this.isProcessing = false;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });

      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild('formUserPopup', { static: true }) formUserPopup: TemplateRef<any>;
  visibleFormUserPopup: MatDialogRef<TemplateRef<any>>;
  formUserPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  addFormusersFunc(form: any, event: any) {
    this.appService.getFormByFormId(form.FORM_ID).subscribe((response: any) => {
      this.isProcessing = false;
      this.formData = response[0];
      this.formData.module = "FORMS";
      this.visibleFormUserPopup = this.dialog.open(this.formUserPopup, this.formUserPopupConfig);
    })
  }

  cancelFormUserFunction() {
    this.visibleFormUserPopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {}

  openAuditTrail(viewType: any, forms: any) {
    this.auditTrail.form_TemplateId_Audit_Trail = this.data.templateId;
    this.auditTrail.refNo = viewType == 'overAll' ? null : forms.FORM_ID;
    this.auditTrail.gridName = 'FORMS';
    this.auditTrail.report_And_Popup_Name = 'Forms Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(forms);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Forms Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };
}
